import React from 'react';
import {
  downloadReportPhotos,
  photoAltLabel,
  type ReportPhoto,
} from './researchReportMedia';

type ResearchReportPhotoStripProps = {
  photos: ReportPhoto[];
  language?: string;
};

export function ResearchReportPhotoStrip({
  photos,
  language = 'en',
}: ResearchReportPhotoStripProps) {
  const es = language === 'es';
  const [selected, setSelected] = React.useState<Set<string>>(() => new Set());
  const [hidden, setHidden] = React.useState<Set<string>>(() => new Set());
  const [busy, setBusy] = React.useState(false);

  const visible = photos.filter((photo) => !hidden.has(photo.src));
  if (visible.length === 0) return null;

  const toggle = (src: string) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(src)) next.delete(src);
      else next.add(src);
      return next;
    });
  };

  const runDownload = async (rows: ReportPhoto[]) => {
    if (!rows.length || busy) return;
    setBusy(true);
    try {
      await downloadReportPhotos(rows);
    } finally {
      setBusy(false);
    }
  };

  const selectedPhotos = visible.filter((photo) => selected.has(photo.src));

  return (
    <div className="dashboard-report-photo-strip" aria-label={es ? 'Fotos' : 'Photos'}>
      <div className="dashboard-report-photo-strip-toolbar">
        <button
          type="button"
          className="dashboard-security-inline-btn"
          disabled={busy || selectedPhotos.length === 0}
          onClick={() => { void runDownload(selectedPhotos); }}
        >
          {es ? 'Descargar seleccionadas' : 'Download selected'}
        </button>
        <button
          type="button"
          className="dashboard-security-inline-btn"
          disabled={busy || visible.length === 0}
          onClick={() => { void runDownload(visible); }}
        >
          {es ? 'Descargar todas' : 'Download all'}
        </button>
      </div>
      {visible.map((photo) => {
        const alt = photoAltLabel(photo.alt);
        return (
          <label key={photo.src} className="dashboard-report-photo-item">
            <input
              type="checkbox"
              checked={selected.has(photo.src)}
              onChange={() => toggle(photo.src)}
              aria-label={es ? `Seleccionar ${alt}` : `Select ${alt}`}
            />
            <a href={photo.src} target="_blank" rel="noopener noreferrer" download>
              <img
                className="dashboard-bio-photo"
                alt={alt}
                src={photo.src}
                referrerPolicy="no-referrer"
                onError={() => {
                  setHidden((prev) => new Set(prev).add(photo.src));
                  setSelected((prev) => {
                    const next = new Set(prev);
                    next.delete(photo.src);
                    return next;
                  });
                }}
              />
            </a>
          </label>
        );
      })}
    </div>
  );
}
